import { useClassified } from "@/contexts/classified";
export const useTags = () => {
    var _a;
    const tags = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tags;
    return {
        isExclusive: !!(tags === null || tags === void 0 ? void 0 : tags.isExclusive),
    };
};
